import CardWithDigram from './CardWithDiagram';

export default CardWithDigram;
